// Thin wrapper around window.location so tests can mock navigation.
// jsdom 26+ makes window.location and its methods non-configurable, which
// makes direct mocking impossible. Only exposes what consumers use today;
// extend the Pick keys as needed.
export const navigationService: Pick<
  Location,
  'reload' | 'assign' | 'pathname'
> = {
  reload: () => window.location.reload(),
  assign: (url) => window.location.assign(url),
  get pathname() {
    return window.location.pathname;
  },
};
